import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children, allowedRoles }) {
    const { user } = useAuth();
    if (user === null)
        return (
            <div className="min-h-screen flex items-center justify-center bg-edu-bg">
                <div className="text-edu-muted text-sm">Cargando…</div>
            </div>
        );
    if (user === false) return <Navigate to="/login" replace />;
    if (allowedRoles && !allowedRoles.includes(user.role)) {
        return <Navigate to={defaultRouteFor(user.role)} replace />;
    }
    return children;
}

export function defaultRouteFor(role) {
    const map = {
        alumno: "/alumno/dashboard",
        profesor: "/profesor/dashboard",
        psicologo: "/psicologo/dashboard",
        padre: "/padre/dashboard",
        administrativo: "/admin/dashboard",
        ejecutivo: "/ejecutivo/dashboard",
    };
    return map[role] || "/login";
}
